// Port of api/fuel/app/classes/controller/api/monty/categories/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT category_id, category_name FROM category WHERE LOWER(category_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND category_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].category_id] = { id: rows[i].category_id, name: rows[i].category_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
